<script setup lang="ts">
    import type { Schemas } from '#shopware';

    const {
        product,
        showContent = true,
        shortenedUnitNames = false
    } = defineProps<{
        product: Schemas['Product'];
        showContent?: boolean;
        shortenedUnitNames?: boolean;
    }>();

    const { t } = useI18n();

    const purchaseUnit = computed(() => product?.calculatedPrice.referencePrice?.purchaseUnit);
    const unitName = computed(() => product?.calculatedPrice.referencePrice?.unitName || '');

    const referencePrice = ref();
    if (product.calculatedCheapestPrice?.referencePrice?.price) {
        referencePrice.value = product.calculatedCheapestPrice?.referencePrice?.price;
    } else {
        referencePrice.value = product.calculatedPrice?.referencePrice?.price;
    }

    const referenceUnit = computed(() => product?.calculatedPrice?.referencePrice?.referenceUnit);

    const unitMap: Record<string, string> = {
        Kilogramm: 'kg',
        Gramm: 'g',
        Liter: 'l'
    };

    const unitReferenceName = computed(() =>
        shortenedUnitNames
            ? unitMap[unitName.value] || unitName.value || t('product.units.piece')
            : unitName.value || t('product.units.piece')
    );
</script>

<template>
    <div
        v-if="purchaseUnit"
        class="product-units"
    >
        <template v-if="showContent">
            <span class="unit">
                {{ t('product.content') }}: {{ purchaseUnit }}
                {{ unitName ? unitName : t('product.units.piece') }}
            </span>
        </template>
        <template v-if="referencePrice">
            &nbsp; (
            <SharedPrice
                :value="referencePrice"
                price-size-small
            />
            /{{ referenceUnit }} {{ unitReferenceName }})
        </template>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/product-price/product-units.scss';
</style>
